module.exports = __webpack_public_path__ + "img/data1-2.563d0fc2.png";